<template>
  <div class="d-flex ml-2 mr-md-4 d-inline-flex flex-wrap">
    <div v-for="(value, name) in visibleAttributes" :key="name">
      <a class="atom-tag" href="#">
        <span>{{ name }}: {{ $filters.strLimit(value, 11) }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { getVisibleAttributes } from "../../plugins/getVisible"
import { useAuthStore } from "@/store/modules/auth"

export default {
  name: "UserAttributesBubbles",
  props: {
    attributes: Object
  },
  setup() {
    const authStore = useAuthStore()

    return { authStore }
  },
  data() {
    return {
      isOpened: false
    }
  },
  computed: {
    visibleAttributes() {
      return getVisibleAttributes(this.attributes, this.authStore.apiUser?.isIotAdmin)
    }
  }
}
</script>
